import { ReactComponent as Filter } from 'assets/icons/icon-filter.svg';

export default Filter;
